import currentDialog from '../shared/dialog-reducer';
import customize from '../shared/customize-reducer';
import feedback from '../shared/feedback-reducer';
import forcePublicView from '../shared/force-public-view-reducer';
import highlights from '../shared/highlights-reducer';
import followers from '../shared/followers-reducer';
import videos from './videos-reducer';
import user from '../shared/user-reducer';

const profileApp = {
  ads: state => state || {},
  author: state => state || {},
  bulkSaves: state => state || false,
  canDismissFeedItems: state => state || false,
  convertTimesToLocal: state => state || false,
  currentDialog,
  customize,
  deviceInfoForLogging: state => state || {},
  feedback,
  feedContentItems: state => state || [],
  followers,
  forcePublicView,
  hideRosterAndSchedule: state => state || false,
  onlyHighlights: state => state || false,
  onlyVideos: state => state || false,
  highlightsAndVideos: state => state || false,
  httpsAllowed: state => state || false,
  isMobile: state => state || false,
  onboarding: state => state || {isDismissed: true},
  presetFilterType: state => state || 0,
  recentlyConvertedTeam: state => state || false,
  subNavItems: state => state || [],
  highlights,
  user,
  videos,
  mediaSnowplowTrackerContext: state => state || null,
  recruiterAccess: false,
};

export default profileApp;
